module.exports = __webpack_public_path__ + "fonts/NoirPro-Bold.bb9d0cc6.woff2";